import { IntegrationModel } from '@/types';

export interface PipedriveIntegrationModel extends IntegrationModel {
    token: string;
    checkActivityAsDone: boolean;
    associateWithDeal: boolean;
}
